


























import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { PayoutRequest } from "@scrile/api-provider/dist/api/PayoutRequestsProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatDate } from "@/lib/time";
import BaseIcon from "@/components/Base/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "TransactionItem",
  components: { ListItem, FormatMoney, BaseIcon },
  props: {
    request: { type: Object as PropType<PayoutRequest>, required: true },
  },
  setup(props) {
    const open = ref(false);

    const time = computed(() => {
      return formatDate(new Date(props.request.time), {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    });

    const statusColorClass = computed(() => {
      switch (props.request.status) {
        case "PAID":
          return "__positive";
        case "DECLINED":
          return "__negative";
        default:
          return "";
      }
    });

    const statusText = computed(() => {
      switch (props.request.status) {
        case "NEW":
          return $t("In processing");
        case "PAID":
          return $t("Paid");
        case "DECLINED":
          return $t("Declined");
      }
    });

    return {
      open,
      time,
      statusColorClass,
      statusText,
    };
  },
});
